class ResponseError extends Error {
  constructor(message, statusCode, customData) {
    super(message);
    this.statusCode = statusCode;
    this.customData = customData;
    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
    this.statusCode = statusCode;
    this.customData = customData;
    Object.setPrototypeOf(this, ResponseError.prototype);
  }
}
export {
  ResponseError
};
//# sourceMappingURL=response-error.js.map
